export const DataHooks = {
  Title: 'Layout.Title',
} as const;
